module.exports = __webpack_public_path__ + "static/media/projects.4b74176d.jpg";